import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../shared';

@Component({
  selector: 'app-user',
  templateUrl: './hospital.component.html'
})
export class HospitalComponent implements OnInit {

  constructor(private router: Router,
    private userService: UserService) { }

  ngOnInit() {
    this.userService.getsession().subscribe(data => {
      if(data.item.userGroupId==19||data.item.userGroupId==20){
        window.localStorage.clear()
         location.href = "./404.html";
      }
        
    })
  }

  onActivate(event) {
    window.scroll(0,0);
}

}
